import { selector, atom } from "recoil";
import { getCareer, getCareerTop } from "../services/apiCalls";

export const careerRefresh = atom({
  key: "careerRefresh",
  default: ""
})

export const editCareerVal = atom({
  key: "editCareerVal",
  default: {}
})

export const createCareerModal = atom({
  key: "createCareerModal",
  default: false
})

export const editCareerModal = atom({
  key: "editCareerModal",
  default: false
})

export const careerTop = selector({
  key: "careerTop",
  get: async ({ get }) => {
    try {
      const res = get(careerRefresh);
      console.log(res)
      const result = await getCareerTop();
      return result.data || [];
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return [];
    }
  }
})

export const career = selector({
  key: "career",
  get: async ({ get }) => {
    try {
      const res = get(careerRefresh);
      console.log(res)
      const result = await getCareer();
      return result.data || [];
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return [];
    }
  }
});